import { render, staticRenderFns } from "./stokGrup.vue?vue&type=template&id=6d3ddccd&scoped=true&"
import script from "./stokGrup.vue?vue&type=script&lang=js&"
export * from "./stokGrup.vue?vue&type=script&lang=js&"
import style0 from "./stokGrup.vue?vue&type=style&index=0&lang=css&"
import style1 from "./stokGrup.vue?vue&type=style&index=1&id=6d3ddccd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ddccd",
  null
  
)

export default component.exports